import React from 'react';
import {icon} from '../functions/icons';

const Checkbox = ({ name, value, checked, onChange, disabled }) => {
  return (
    <label className={`custom-checkbox ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="checkbox-icon">{icon("checkbox-check")}</span>
    </label>
  );
};

export default Checkbox;
